import * as REDUX_TYPES from '../types'
export const setCategoryMode = (categoryMode) => {
    return {
        type: REDUX_TYPES.FETCH.CATEGORY_MODE,
        categoryMode
    }
}
export const setFetchInProgress = (fetchInProgress) => {
    return {
        type: REDUX_TYPES.FETCH.FETCH_IN_PROGRESS,
        fetchInProgress,
    }
}

export const setFetchStart = (fetchStart) => {
    return {
        type: REDUX_TYPES.FETCH.FETCH_START,
        fetchStart,
    }
}
export const setQuery = (query) => {
    return {
        type: REDUX_TYPES.FETCH.QUERY,
        query,
    }
}

export const setRefetchMessageId = (refetchMessageId) => {
    return {
        type: REDUX_TYPES.FETCH.REFETCH_MESSAGE_ID,
        refetchMessageId,
    }
}
